export default function createDeferred() {
  let resolve: (v?: any) => void = () => {};
  let reject: (reason?: string) => void = () => {};
  const promise = new Promise((r, rj) => {
    resolve = r;
    reject = rj;
  });
  return {
    promise,
    resolve,
    reject,
  };
}
